
import React from 'react';
import { motion } from 'framer-motion';
import { protocolData } from '../data';
import { FiChevronRight } from 'react-icons/fi';
import './CaseSummary.css';

const CaseSummary = () => {
    const { caseSummary } = protocolData;

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { x: -20, opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: {
                duration: 0.5,
            },
        },
    };

    return (
        <motion.section
            id="case-summary"
            className="section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5 }}
        >
            <h2 className="section-title">{caseSummary.title}</h2>
            <div className="timeline-container">
                <motion.ul
                    className="timeline"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                >
                    {caseSummary.chronology.map((event, index) => (
                        <motion.li key={index} className="timeline-item" variants={itemVariants}>
                            <div className="timeline-marker">
                                <FiChevronRight />
                            </div>
                            <div className="timeline-content">
                                <h3>{event.step}</h3>
                                <p>{event.description}</p>
                            </div>
                        </motion.li>
                    ))}
                </motion.ul>
            </div>
        </motion.section>
    );
};

export default CaseSummary;
